let moduleData = {
  modules: {
    register: { page_route: "/riders", menu_name: "Riders" },
    arrivals: { page_route: "/arrivals", menu_name: "Arrivals" },
    track: { page_route: "/trackers", menu_name: "Trackers" },
    users: { page_route: "/users", menu_name: "Users" },
  },
  staff_modules: {
    users: { page_route: "/users", menu_name: "Users" },
  },
};

export { moduleData };
